module.exports = __webpack_public_path__ + "img/HeBo Trailers-24.f646314c.jpg";